export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_FEAT_MEMBERSHIP_COMMERCE_DUES: 'membership-commerce-dues',
  FLAG_FEAT_MERGE_CCMS_M360_INVOICE_REQS: 'merge-ccms-m360-invoice-reqs',
  FLAG_FEAT_EARN_CREDITS_REDIRECT: 'membership-app-pdr-videos-prod-release',
  FLAG_FEAT_UNIFIED_INVOICES: 'membership-unified-invoices',
  FLAG_FEAT_ANNUAL_SURVEY: 'membership-annual-survey-link',
  FLAG_FEAT_MEMBERSHIP_NEW_PAYMENT_FLOW: 'membership-new-payment-flow',
  FLAG_FEAT_MEMBERSHIP_PDR_REQUIREMENTS: 'membership-pdr-requirements',
  FLAG_FEAT_MEMBERSHIP_JOURNEY_DASHBOARD: 'membership-journey-dashboard',
  FLAG_SALESFORCE_MIGRATION_STATUS: 'backoffice-salesforce-migration'
}
